/* ============================================================
   BBRU filter bug fix
   ------------------------------------------------------------
   Patches booster.js to fix the colour filter (and any tag-based
   filter) failing silently with TypeError on response handling.

   Root cause:
   - When an AJAX filter request returns a response where
     json.filters is null/undefined OR fails to parse, line 1855
     of booster.js calls Object.entries(json.filters) which
     throws "Cannot convert undefined or null to object".
   - The error breaks the response handler — the user sees the
     URL update briefly then revert, OR (depending on timing)
     no visible change at all. The product grid is never updated.

   The fix:
   - Add null guard around Object.entries call.
   - Add try/catch around renderFilters body so a single bad
     filter response doesn't break the whole filter UI state.
   - Add console.warn in dev so the underlying issue is
     visible if it happens again.

   ============================================================
   HOW TO APPLY
   ------------------------------------------------------------
   This patch modifies assets/booster.js. Replace lines 1852-1875
   (the renderFilters method) with the version below.

   Booster.js is a vendor file — making changes will be lost on
   theme update. Two options:

   Option A (quick): Edit booster.js directly. Add a comment at
   the top noting the patch and what was changed so future devs
   know.

   Option B (cleaner): Override the BstrFilters.prototype.renderFilters
   method from a separate JS file loaded after booster.js. Snippet
   for this is at the bottom of this file.

   ============================================================ */


/* ----- Option A: replacement for renderFilters at line 1852 ----- */

/*
    renderFilters(json){
        this.setInputState(true)

        // BBRU PATCH: guard against missing/malformed filter data in response
        if (!json || !json.filters || typeof json.filters !== 'object') {
            console.warn('[BBRU filter] renderFilters called with missing json.filters', json);
            return;
        }

        try {
            for(let [k, v] of Object.entries(json.filters)){
                if (!Array.isArray(v)) continue;

                for(let f of v){
                    let t = document.querySelector(`[data-filter="${k}-${f.value}"]`);
                    if (t) {
                        let c = t.nextElementSibling;
                        if (c) {
                            let spanElement = c.querySelector('[data-filter-count]');
                            if (spanElement) spanElement.innerText = String(f.count);
                        }
                        t.disabled = !f.count;
                        t.checked = f.active;
                        if (f.urls) {
                            t.dataset.filterHref = f.active ? f.urls.remove : f.urls.add;
                        }
                        let parent = t.closest('div');
                        if (parent) {
                            if (f.count) {
                                parent.classList.remove('filter--disabled');
                            } else {
                                parent.classList.add('filter--disabled');
                            }
                        }
                    }
                }
            }
        } catch (err) {
            console.warn('[BBRU filter] renderFilters threw, continuing without UI update', err);
        }
    }
*/


/* ----- Option B: external override (recommended) -----
   Save this as assets/bbru-filter-fix.js and include it from
   layout/theme.liquid AFTER the booster.js script tag:

     <script src="{{ 'bbru-filter-fix.js' | asset_url }}" defer></script>
*/

(function(){
    if (typeof BstrFilters === 'undefined') {
        // booster.js hasn't loaded yet, retry shortly
        if (window._bbruFilterFixRetries === undefined) window._bbruFilterFixRetries = 0;
        if (window._bbruFilterFixRetries++ < 20) {
            setTimeout(arguments.callee, 100);
        } else {
            console.warn('[BBRU filter fix] BstrFilters not found after 20 retries, giving up');
        }
        return;
    }

    var originalRenderFilters = BstrFilters.prototype.renderFilters;

    BstrFilters.prototype.renderFilters = function(json){
        this.setInputState(true);

        if (!json || !json.filters || typeof json.filters !== 'object') {
            console.warn('[BBRU filter fix] renderFilters: json.filters missing or invalid', json);
            return;
        }

        try {
            for (var k in json.filters) {
                if (!Object.prototype.hasOwnProperty.call(json.filters, k)) continue;
                var v = json.filters[k];
                if (!Array.isArray(v)) continue;

                for (var i = 0; i < v.length; i++) {
                    var f = v[i];
                    var t = document.querySelector('[data-filter="' + k + '-' + f.value + '"]');
                    if (!t) continue;

                    var c = t.nextElementSibling;
                    if (c) {
                        var span = c.querySelector('[data-filter-count]');
                        if (span) span.innerText = String(f.count);
                    }
                    t.disabled = !f.count;
                    t.checked = f.active;
                    if (f.urls) {
                        t.dataset.filterHref = f.active ? f.urls.remove : f.urls.add;
                    }
                    var parent = t.closest('div');
                    if (parent) {
                        if (f.count) {
                            parent.classList.remove('filter--disabled');
                        } else {
                            parent.classList.add('filter--disabled');
                        }
                    }
                }
            }
        } catch (err) {
            console.warn('[BBRU filter fix] renderFilters threw, swallowing', err);
        }
    };

    console.info('[BBRU filter fix] BstrFilters.renderFilters patched');
})();
